// extracted by mini-css-extract-plugin
module.exports = {"intro":"HowItWorks_intro__2boQc"};